import { Grid, IconButton } from '@material-ui/core';
import React from 'react';
import { apiUrl } from '../../../../../common/constants/apiUrl';
import { ImageDto } from '../../../groupVisits.dtos';
import DownloadIcon from '@material-ui/icons/GetApp';
import { saveAs } from 'file-saver';

interface IProps {
  image: ImageDto;
}

const ImageCard: React.FC<IProps> = ({ image }) => {
  const url = `${apiUrl}/groupVisits/image/${image.imageFileName}`;
  return (
    <Grid item style={{ width: '250px', margin: '10px', position: 'relative' }}>
      <IconButton
        aria-label='Download'
        onClick={() => {
          saveAs(url, image.imageFileName);
        }}
        style={{
          position: 'absolute',
          right: 0,
          backgroundColor: '#1212128c',
          color: 'white',
          padding: '5px',
          zIndex: 10,
        }}
      >
        <DownloadIcon />
      </IconButton>
      {image.mimeType == 'image/jpg' || image.mimeType == 'image/jpeg' ? (
        <img src={url} alt='group image' style={{ width: '100%' }} />
      ) : (
        <video src={url} style={{ width: '100%' }} controls />
      )}
    </Grid>
  );
};

export default ImageCard;
